import { aclHandlers, columnHandlers, createAddPluginHandler, entityHandlers, enumHandlers, relationHandlers, removePluginHandler, respondHandlers, schemaCommentHandlers, schemaFieldHandlers, uniqueHandler, } from './stmts';
export const statementSchemaHandlerList = statementSchemaPluginHandler => [
    ...aclHandlers,
    ...columnHandlers,
    ...entityHandlers,
    ...enumHandlers,
    ...schemaFieldHandlers,
    ...relationHandlers,
    uniqueHandler,
    ...schemaCommentHandlers,
    removePluginHandler,
    ...respondHandlers,
    createAddPluginHandler({
        ...statementSchemaPluginHandler,
    }),
];
export const statementSchemaHandlerMap = (statementSchemaPluginHandler) => {
    return Object.fromEntries(statementSchemaHandlerList(statementSchemaPluginHandler).map(it => [it.type, it]));
};
//# sourceMappingURL=stmtsList.js.map